// Smooth scroll to Tech Specs section on button click
document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector(".specs-grid__button");
  if (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      const target = document.querySelector(".section-tech-spec");
      if (target) {
        // Get the header height dynamically if possible, or use a fallback
        const header =
          document.querySelector(".header-wrapper") ||
          document.querySelector("header");
        const headerOffset = header ? header.offsetHeight : 0;
        const additionalOffset = 20; // Extra breathing room

        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition =
          elementPosition +
          window.pageYOffset -
          headerOffset -
          additionalOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    });
  }
});

// Keep the homepage header transparent no matter which section is first
document.addEventListener("DOMContentLoaded", function () {
  if (!document.body.classList.contains("template-index")) return;
  const headerSection = document.querySelector(".header-section");
  if (!headerSection) return;
  const forceTransparent = function () {
    headerSection.classList.add("header-transparent");
  };
  forceTransparent();
  ["shopify:section:load", "shopify:section:unload", "shopify:section:reorder"].forEach(
    function (evt) {
      document.addEventListener(evt, function () {
        setTimeout(forceTransparent, 0);
      });
    }
  );
});

// Three-column parts mega menu: brand -> model -> part category.
//
// Everything is already in the DOM; this only flips `hidden` and `aria-expanded`. Listeners are
// delegated on document so they also cover menus that arrive later through the Section
// Rendering API — there is no init step to miss and nothing to tear down.
(function () {
  var HOVER_DELAY = 120;
  var hoverTimer = null;

  function root(el) {
    return el && el.closest ? el.closest("[data-mega-columns]") : null;
  }

  function show(scope, attribute, key) {
    var lists = scope.querySelectorAll("[" + attribute + "]");
    for (var i = 0; i < lists.length; i++) {
      lists[i].hidden = lists[i].getAttribute(attribute) !== key;
    }
  }

  function mark(scope, selector, active) {
    var rows = scope.querySelectorAll(selector);
    for (var i = 0; i < rows.length; i++) {
      rows[i].setAttribute("aria-expanded", rows[i] === active ? "true" : "false");
    }
  }

  function selectBrand(scope, row) {
    show(scope, "data-mega-models", row.dataset.megaBrand);
    mark(scope, "[data-mega-brand]", row);
    // A new brand invalidates whichever model was open, so column 3 goes back to the
    // shop-wide categories rather than showing the previous bike's parts.
    show(scope, "data-mega-cats", "default");
    mark(scope, "[data-mega-model]", null);
  }

  function selectModel(scope, row) {
    show(scope, "data-mega-cats", row.dataset.megaModel);
    mark(scope, "[data-mega-model]", row);
  }

  function activate(row, immediate) {
    var scope = root(row);
    if (!scope) return;

    clearTimeout(hoverTimer);
    var run = function () {
      if (row.dataset.megaBrand !== undefined) selectBrand(scope, row);
      else if (row.dataset.megaModel !== undefined) selectModel(scope, row);
    };
    // Debounce is load-bearing: dragging the pointer down column 1 fires pointerover on every
    // row, and without it column 2 and 3 thrash through every brand on the way past.
    if (immediate) run();
    else hoverTimer = setTimeout(run, HOVER_DELAY);
  }

  document.addEventListener("pointerover", function (event) {
    var row = event.target.closest && event.target.closest("[data-mega-brand], [data-mega-model]");
    if (row) activate(row, false);
  });

  // Keyboard users arrive through focus, where waiting would feel broken.
  document.addEventListener("focusin", function (event) {
    var row = event.target.closest && event.target.closest("[data-mega-brand], [data-mega-model]");
    if (row) activate(row, true);
  });

  // Brand and model rows are drill targets, not links — a click must not close the menu.
  document.addEventListener("click", function (event) {
    var row = event.target.closest && event.target.closest("[data-mega-brand], [data-mega-model]");
    if (!row || !root(row)) return;
    event.preventDefault();
    activate(row, true);
  });

  document.addEventListener("keydown", function (event) {
    var row = event.target.closest && event.target.closest(".mega-menu__row");
    var scope = root(row);
    if (!scope) return;

    var column = row.closest(".mega-menu__col");
    var keys = ["ArrowDown", "ArrowUp", "ArrowRight", "ArrowLeft"];
    if (keys.indexOf(event.key) === -1) return;

    var siblings = Array.prototype.filter.call(
      column.querySelectorAll(".mega-menu__row"),
      function (el) {
        return el.offsetParent !== null;
      }
    );
    var index = siblings.indexOf(row);
    var target = null;

    if (event.key === "ArrowDown") target = siblings[index + 1];
    else if (event.key === "ArrowUp") target = siblings[index - 1];
    else if (event.key === "ArrowRight") {
      // Open this row's list first, then step into it.
      activate(row, true);
      var next = column.closest(".mega-menu__item").nextElementSibling;
      var list = next && next.querySelector(".mega-menu__col:not([hidden])");
      target = list && list.querySelector(".mega-menu__row");
    } else if (event.key === "ArrowLeft") {
      var prev = column.closest(".mega-menu__item").previousElementSibling;
      var prevList = prev && prev.querySelector(".mega-menu__col:not([hidden])");
      target =
        (prevList && prevList.querySelector('[aria-expanded="true"]')) ||
        (prevList && prevList.querySelector(".mega-menu__row"));
    }

    if (target) {
      event.preventDefault();
      target.focus();
    }
  });
})();
